import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as smartConnectServices from "../../../services/smartConnect/smartConnect.services.js";

//ADD DIDs
export const smartConnectAddDIDs = createAsyncThunk(
    "smartConnect/addDids",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.addDIDs(payload);
            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to add DIDs"
                );
            }

            return res;
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Error while adding DIDs"
            );
        }
    }
);

export const unAssignedAgentCurrentDid = createAsyncThunk(
    "smartConnect/unAssignCurrentDid",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.unAssignedAgentCurrentDid(payload);
            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to UnAssign DID"
                );
            }
            return res.message;
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Error while UnAssigning DID"
            );
        }
    }
);

//FETCH DIDs
export const SmartConnectFetchDids = createAsyncThunk(
    "smartConnect/fetchDids",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.fetchDIDs(payload);
            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to fetch DIDs"
                );
            }

            return {
                data: res?.data || [],
                pagination: res?.pagination || {},
            };
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Error while fetching DIDs"
            );
        }
    }
);

export const SmartConnectFetchDidsFromAgentAssignmentDid = createAsyncThunk(
    "smartConnect/fetchDidsFromAgentAssignment",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.fetchDidsFromAgentAssignmentDid(payload);
            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to fetch DIDs From Assignment"
                );
            }

            return {
                data: res?.data || [],
                pagination: res?.pagination || {},
            };
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Error while fetching DIDs From Assigment"
            );
        }
    }
);

export const smartConnectViewAssignedDids = createAsyncThunk(
    "smartConnect/viewAgentAssignedDids",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.viewAgentAssignedDids(payload);
            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to fetch Agent Assigned DIDs From Assignment List"
                );
            }

            return {
                data: res?.data || [],
                pagination: res?.pagination || {},
            };
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Error while fetching Agent Assigned DIDs From Assigment List"
            );
        }
    }
);

export const assignDidToCsmAgents = createAsyncThunk(
    "smartConnect/assignDidsToCsmAgents",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.assignDidToCsmAgents(payload);
            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to Assign DID"
                );
            }

            return res.message;
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Error while Assigning DIDs"
            );
        }
    }
);


export const getSpammedDidList = createAsyncThunk(
    "smartConnect/getSpammedDidList",
    async (payload, { rejectWithValue }) => {
        try {
            const res = await smartConnectServices.fetchSpammedDidList(payload);
            if (!res?.success) {
                return rejectWithValue(
                    res?.message || "Failed to fetch Spammed DIDs"
                );
            }

            return {
                data: res?.data || [],
                pagination: res?.pagination || {},
            };
        } catch (err) {
            return rejectWithValue(
                err?.response?.data?.message ||
                "Internal Server Error while fetching Spammed DIDs"
            );
        }
    }
);

const initialState = {
    data: [],
    pagination: {},
    loading: false,
    uploading: false,
    error: null,
    uploadResult: null,
    agentAssignment: {
        data: [],
        pagination: {},
        loading: false,
        error: null,
    },
    viewDids: {
        data: [],
        pagination: {},
        loading: false,
        error: null
    },
    spammedDids: {
        data: [],
        pagination: {},
        loading: false,
        error: null
    }
};

const smartConnectDIDsSlice = createSlice({
    name: "smartConnectDIDs",
    initialState,
    reducers: {
        resetUploadResult: (state) => {
            state.uploadResult = null;
        },
    },
    extraReducers: (builder) => {
        builder

            // SPAMMED DID LIST 
            .addCase(getSpammedDidList.pending, (state) => {
                state.spammedDids.loading = true;
                state.spammedDids.error = null;
            })
            .addCase(getSpammedDidList.fulfilled, (state, action) => {
                state.spammedDids.loading = false;
                state.spammedDids.data = action.payload.data;
                state.spammedDids.pagination = action.payload.pagination;
                state.spammedDids.error = null;
            })
            .addCase(getSpammedDidList.rejected, (state, action) => {
                state.spammedDids.loading = false;
                state.spammedDids.err = action.payload;
            })

            // VIEW ASSIGNED DIDs 
            .addCase(smartConnectViewAssignedDids.pending, (state) => {
                state.viewDids.loading = true;
                state.viewDids.error = null;
            })
            .addCase(smartConnectViewAssignedDids.fulfilled, (state, action) => {
                state.viewDids.loading = false;
                state.viewDids.data = action.payload.data;
                state.viewDids.pagination = action.payload.pagination;
                state.viewDids.error = null;
            })
            .addCase(smartConnectViewAssignedDids.rejected, (state, action) => {
                state.viewDids.loading = false;
                state.viewDids.err = action.payload;
            })

            // FETCH ASSIGNED DIDs 
            .addCase(SmartConnectFetchDidsFromAgentAssignmentDid.pending, (state) => {
                state.agentAssignment.loading = true;
                state.agentAssignment.error = null;
            })
            .addCase(SmartConnectFetchDidsFromAgentAssignmentDid.fulfilled, (state, action) => {
                state.agentAssignment.loading = false;
                state.agentAssignment.data = action.payload.data;
                state.agentAssignment.pagination = action.payload.pagination;
                state.agentAssignment.error = null;
            })
            .addCase(SmartConnectFetchDidsFromAgentAssignmentDid.rejected, (state, action) => {
                state.agentAssignment.loading = false;
                state.agentAssignment.err = action.payload;
            })

            // FETCH DIDs 
            .addCase(SmartConnectFetchDids.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(SmartConnectFetchDids.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload.data;
                state.pagination = action.payload.pagination;
            })
            .addCase(SmartConnectFetchDids.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // ADD DIDs
            .addCase(smartConnectAddDIDs.pending, (state) => {
                state.uploading = true;
                state.error = null;
                state.uploadResult = null;
            })
            .addCase(smartConnectAddDIDs.fulfilled, (state, action) => {
                state.uploading = false;
                state.uploadResult = action.payload;
            })
            .addCase(smartConnectAddDIDs.rejected, (state, action) => {
                state.uploading = false;
                state.error = action.payload;
            });
    },
});

export const { resetUploadResult } = smartConnectDIDsSlice.actions;
export const smartConnectDIDsReducer = smartConnectDIDsSlice.reducer;
